<template>
    <!--<footer class="foot-bg" :class="$route.name=='Home'?'foot-bgw':''">-->
        <!--<div class="main-container">-->
            <!--&lt;!&ndash;<h4><img src=""/>采购投诉反馈</h4>&ndash;&gt;-->
            <!--<el-row class="foot-title">-->
                <!--<el-col>-->
                   <!--<span class="boldLine"></span>采购投诉反馈-->
                <!--</el-col>-->
            <!--</el-row>-->
            <!--<el-row>-->
                <!--<el-col :span="8">-->
                    <!--<p >廉洁举报电话：86-10-8440 8717</p>-->
                    <!--<p >廉洁举报邮箱：sunnymoma@modernland.hk</p>-->
                <!--</el-col>-->
                <!--<el-col :span="8">-->
                    <!--<p >廉洁举报信件邮寄地址：北京香河园路1号万国城 10号楼4层</p>-->
                    <!--<p >邮编：100028</p>-->
                <!--</el-col>-->
                <!--<el-col :span="8" class="pic_right">-->
                    <!--<img src="../../assets/images/index/fpptLogo.png"/>-->
                <!--</el-col>-->
            <!--</el-row>-->
        <!--</div>-->
        <!--<div class="text-center copy">版权所有Copyright©2018 ΜΟΜΛ当代节能置业招采平台</div>-->
    <!--</footer>-->

    <div class="footer">
        <div class="box">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-col :span="12" class="left">
                        <div>帮助服务</div>
                        <div>Help Center</div>
                    </el-col>
                    <el-col :span="12" class="right">
                        <div>供应商帮助招商</div>
                        <div>周一到周五：08:30 ~ 17:00</div>
                    </el-col>
                </el-col>
                <el-col :span="6">
                    <el-col :span="12" class="left">
                        <div>联系方式</div>
                        <div>Contact Us</div>
                    </el-col>
                    <el-col :span="12" class="right">
                        <div>邮编：200442</div>
                        <div>地址：北京市朝阳区合生汇</div>
                        <div>邮箱：fwsj@cre-hopson.com</div>
                    </el-col>
                </el-col>
              <el-col :span="6">
                    <el-col :span="12" class="left">
                        <div>投诉举报</div>
                    </el-col>
                    <el-col :span="12" class="right">
                        <img class="ewm" src="../../assets/images/login/erweima.jpg" alt="">
                    </el-col>
                </el-col>
            </el-row>
            <div style="text-align: center;color: #9B9B9B;font-size: 12px;margin-top: 10px">合商科技有限公司 版权所有粤ICP备19055132号</div>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'my-footer',
        data() {
            return{

            }
        }
    }
</script>
<style lang="scss">>
    .foot-bg {
        background: #141827;
    }
    .foot-bgw {
        background: #fff;
    }
    .foot-bg .main-container {
        /*margin-bottom: 84px;*/
        margin: 30px auto;
        position: relative;
    }
    .foot-bg .el-col {
        font-size: 14px;
        color: #fff;
        text-align: left;
        line-height: 28px;
    }
    .foot-title .el-col {
        font-size: 16px;
        font-weight: 700;
        margin-top: 24px;
        margin-bottom: 30px;
    }
    .boldLine {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #fff;
        vertical-align: middle;
        margin-right: 8px;
    }
    .foot-bg .el-col p {margin: 0;padding: 0;}
    .foot-bg .copy {
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        /*color: #C4CACD;*/
        color: #fff;
        background: #2D3336;
    }
    .foot-bg .pic_right {
        text-align: right;
    }
    .pic_right img {
        width: 80px;
        height: 106.9px;
        position: absolute;
        right: 10px;
        top: -50px;
    }





    .footer{
        z-index: 999;
        background: #002247;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 120px;
        left: 0;
        color: #ffffff;
        font-size: 12px;
        padding-top: 15px;
        padding-bottom: 10px;
        .box{
            width: 1200px;
            margin: 0 auto;
        }
        .left{
            text-align: right;
        }
        .right{
            text-align: left;
            div{
                margin-bottom: 5px;
            }
        }
        .ewm{
            width: 80px;
            height: 80px;
        }
      }
</style>



// WEBPACK FOOTER //
// src/pages/common/Footer.vue